import React from 'react';
import { tomos } from '../data/constants';
export function ProductOverview() {
  return <section className="py-16 md:py-24 px-4 max-w-6xl mx-auto" data-id="element-379">
      <div className="text-center mb-12 md:mb-20" data-id="element-380">
        <h2 className="text-3xl md:text-5xl font-extrabold mb-6 tracking-tight" data-id="element-381">
          ¿Qué recibís <span className="text-primary" data-id="element-382">exactamente?</span>
        </h2>
        <p className="text-lg md:text-xl text-zinc-400 max-w-2xl mx-auto" data-id="element-383">
          Un recorrido estructurado de 52 semanas diseñado para llevar a tus
          alumnos al máximo nivel, sin que vos tengas que planificar una sola
          clase.
        </p>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8" data-id="element-384">
        {tomos.map((t, i) => <div key={t.id} className="bg-surface border border-zinc-800 rounded-3xl p-8 flex flex-col hover:border-primary/50 transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_10px_40px_rgba(249,168,212,0.1)]" data-id="element-385">
            <div className="flex items-center justify-between mb-6" data-id="element-386">
              <span className="text-4xl" data-id="element-387">{t.icon}</span>
              <span className="bg-primary/10 text-primary text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wider" data-id="element-388">
                {t.months}
              </span>
            </div>

            <div className="mb-4" data-id="element-389">
              <div className="text-zinc-500 text-sm font-bold uppercase tracking-wider mb-1" data-id="element-390">
                Tomo {i + 1}
              </div>
              <h3 className="text-xl md:text-2xl font-extrabold text-white leading-tight" data-id="element-391">
                {t.name}
              </h3>
            </div>

            <p className="text-zinc-400 leading-relaxed flex-grow" data-id="element-392">
              {t.content}
            </p>
          </div>)}
      </div>
    </section>;
}